// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_BuscaDadosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /orcamentos/buscaDados
 *
 * Returns list of orcamentos with filter scoping applied.
 */
import type { Orcamentos_BuscaDadosRow } from './Orcamentos_BuscaDadosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orcamentos_BuscaDadosResponseDados = Orcamentos_BuscaDadosRow[];

export type Orcamentos_BuscaDadosResponse = ApiResponse<Orcamentos_BuscaDadosResponseDados>;

registerResponseContract('Orcamentos_BuscaDadosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:                      { type: 'number',  required: true },
      acoes:                   { type: 'number',  required: true },
      agendar:                 { type: 'number',  required: true },
      status:                  { type: 'string',  required: true },
      status_label:            { type: 'string',  required: true },
      orcamento_data:          { type: 'string',  required: false },
      orcamento_franquia_id:   { type: 'number',  required: true },
      nome_cliente:            { type: 'string',  required: false },
      pode_agendar:            { type: 'number',  required: true },
      agendar_motivos:         { type: 'array',   required: false },
      cliente_id:              { type: 'number',  required: false },
      cliente_ddi:             { type: 'string',  required: false },
      cliente_ddd:             { type: 'string',  required: false },
      cliente_telefone:        { type: 'string',  required: false },
      rua:                     { type: 'string',  required: false },
      bairro:                  { type: 'string',  required: false },
      orcamento_location_id:   { type: 'number',  required: false },
      orcamento_location_type: { type: 'string',  required: false },
      total:                   { type: 'number',  required: true },
      origem:                  { type: 'string',  required: false },
      franquia:                { type: 'string',  required: false },
      Localidade:              { type: 'string',  required: false },
    },
  },
})
